import { render, staticRenderFns } from "./email-visualizer.vue?vue&type=template&id=2d5dcf9a&scoped=true&"
import script from "./email-visualizer.vue?vue&type=script&lang=js&"
export * from "./email-visualizer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5dcf9a",
  null
  
)

export default component.exports